import React from "react";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from "react-bootstrap";
import Spinner from '../../../SharedModules/Spinner/Spinner';
import { verifyOrgDetails,addOrganizationForUser, getOrganizationForUser, updateUserRolesAction, getOrgDetails } from '../action'
import * as ErrorConst from '../../../SharedModules/Messages/ErrorMsgConstants_copy';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CustomHelpIcon from "../../../SharedModules/InfoIcon/HelpIcon";
import * as ManageAccountConstants from '../../UserSearch/ManageAccountConstants'


function AddOrganization(props) {
  const dispatch = useDispatch();
  const [spinnerLoader, setspinnerLoader] = React.useState(false);
  const userData = JSON.stringify(localStorage.getItem("orgList"));
  let loginState = JSON.parse(localStorage.getItem('loginState'));
  const verifyOrg = data => dispatch(verifyOrgDetails(data));
  const addOrganizationDetails = (userId, orgData, addNPI) => dispatch(addOrganizationForUser(userId, orgData, addNPI));
  const getOrganizationDetails = userId => dispatch(getOrganizationForUser(userId));
  const onUpdateRoles = (data, orgId) => dispatch(updateUserRolesAction(data, orgId));
  const verifyOrgDetailValues = useSelector(
      state => state.organizationDetails.validateOrgResponse
    );
    const addOrgData = useSelector( state => state.organizationDetails.addOrgData );
    const getOrgData = useSelector( state => state.organizationDetails.getOrgData );
 const [
    {
      provMedIDErr,
      provEINErr,
      provLocZipCodeErr,
      provMedIDExistingErr,
      provNPIReqErr,
    },
    setErrors,
  ] = React.useState(false);

  const handleChange = name => event => {
    if(name === 'userRegister'){
      setErrors({});
      props.setErrorMessages([]);
    }
    props.setOrgValues({ ...props.orgValues, [name]: event.target.value });
  };

  const verifyBtn = () => {
      let errorMessagesArray = [];
      setspinnerLoader(true);  
      setErrors({
        provMedIDErr:
          !props.orgValues.providerMedicaidID && props.orgValues.userRegister === 'registerProvider'
            ? (() => {
                errorMessagesArray.push(ErrorConst.PROVIDER_ID_REQ);
                return true;
              })()
            : false,
        provEINErr: !props.orgValues.providerEINSSN
          ? (() => {
              errorMessagesArray.push(ErrorConst.PROVIDER_EIN_REQ);
              return true;
            })()
          : false,
          provLocZipCodeErr: !props.orgValues.providerZipCode
            ? (() => {
                errorMessagesArray.push(ErrorConst.PROVIDER_LOC_ZP_REQ);
                return true;
              })()
            : false,
        provNPIReqErr:
          !props.orgValues.providerNPI && props.orgValues.userRegister === 'registerNPI'
            ? (() => {
              errorMessagesArray.push(ErrorConst.PROVIDER_NPI_REQ);
              return true;
            })()
            : false,
      });
      if (errorMessagesArray.length > 0) {
        props.setErrorMessages(errorMessagesArray);
        setspinnerLoader(false);
        return false;
      } 
      else {
       let providerData = JSON.parse(localStorage.getItem("orgList"))
        if (
          props.orgValues.providerMedicaidID && providerData?.some(i => i.orgId === props.orgValues.providerMedicaidID)
        ) {
          props.setSuccessMessages([]);
          props.setErrorMessages([ErrorConst.PROVIDER_ALREADY_EXISTS]);
          props.setLandingPage(true)
          props.setShowAddOrg(false)
        }else {
          let data = {
            providerMedicaidID: props.orgValues.providerMedicaidID || '',
            providerNPI: props.orgValues.providerNPI || '',
            providerEINSSN: props.orgValues.providerEINSSN || '',
            providerZipCode: props.orgValues.providerZipCode || '',
            userRegister: props.orgValues.userRegister === 'registerProvider' ? 'Provider' : 'NPI',
          };
          verifyOrg(data);
        }
      }
  };

   const orgRoleForWP = [
          {
              "_id": process.env.REACT_APP_ORG_ADMIN_ROLE,
              "name": process.env.REACT_APP_ORG_ADMIN_ROLE
          }
  ]

  const OrgRoleForPED = [
    {
      "_id": process.env.REACT_APP_ELIGIBILITY_ROLE,
      "name": process.env.REACT_APP_ELIGIBILITY_ROLE,
    }
  ]

  const getProviderUsers = (data) => {
    const providerUsersList = data?.map(e => {
        return {
            orgId: e?.pAltId,
            name: e?.pSortNam,
            description: `${e?.pAltId}-${e?.pSortNam}`,
            npiId: e?.npi,
            organizationRoles: e?.providerPE ? OrgRoleForPED : orgRoleForWP,
        };
    });
    return providerUsersList;
};
const getPEProviders = (data) => {
  const peProvidersList = data?.filter(e => {
    if(e.providerPE){
      return e
    }
  })
  return peProvidersList || [];
};

   React.useEffect(() => {
      if (verifyOrgDetailValues) {
        const addNPI = props.orgValues.userRegister === 'registerNPI'
        setspinnerLoader(false);
        if (verifyOrgDetailValues.status == 'INTERNAL_SERVER_ERROR') {
          if(verifyOrgDetailValues.message == '929300001'){
            props.setErrorMessages([ErrorConst.PROVIDER_NOT_FOUND]);
          }else if(verifyOrgDetailValues.message == '929300004'){
            props.setErrorMessages([ErrorConst.MULTI_NPI_PROVIDERS]);
          }else{
            props.setErrorMessages([ErrorConst.GENERIC_SYSTEM_ERROR]);
          }
        }
        else if (verifyOrgDetailValues.data?.length) {
            props.setErrorMessages([]);
            setspinnerLoader(true);
          let orgData = {
            userOrgList: getProviderUsers(verifyOrgDetailValues.data)
          };
          
            addOrganizationDetails(loginState?.loginUserId, orgData, addNPI);
      }       
      }else {
          props.setSuccessMessages([]);
      }
    }, [verifyOrgDetailValues]);

    React.useEffect(()=>{
      if(addOrgData && addOrgData.statusCode === "01"){
        getOrganizationDetails(loginState?.loginUserId);
      }else if(addOrgData?.statusCode == "ORG_ADMIN_AVAILABLE"){
        props.setErrorMessages([ErrorConst.ORG_VERIFICATION_FAILED]);
        setspinnerLoader(false);
      }
    }, [addOrgData]);

    React.useEffect(()=>{      
        if(getOrgData) {
          localStorage.setItem('orgList', JSON.stringify(getOrgData.responseObject.userOrgList));
          const fusePayload = {
            userRoles : getOrgData.responseObject.userOrgList
          }
          onUpdateRoles(fusePayload, loginState?.clientMappingKey || loginState?.loginUserId);
          props.setLandingPage(true);
          props.setShowAddOrg(false);          
          props.setSuccessMessages([ErrorConst.PROVIDER_SUCCESS_MSG]);
          setspinnerLoader(false);
        }
    },[getOrgData])

  return (
    <>
    {spinnerLoader ? <Spinner setspinnerLoader={setspinnerLoader} /> : null}
      <div className="set-logOut">
        <div className="welcome-user">
          <p className="heading-text mt-1">
            Register your {process.env.REACT_APP_ORGANIZATION_FOR_NM} Provider Medicaid identifiers to access Provider Claims Portal. Click on the <span className="fa fa-question-circle-o" aria-hidden="true" /> icon to learn more
          </p>
          <div className="sub-radio mt-2 ml-4">
                    <RadioGroup
                      row
                      aria-label="standard-radio-desc"
                      name="userRegister"
                      onChange={handleChange("userRegister")}
                      className="ml-0"
                    >
                      <FormControlLabel
                        value="registerProvider"
                        id="standard-radio-desc-startswith"
                        control={<Radio color="primary" />}
                        label={<span>Register Provider ID<CustomHelpIcon msg={ManageAccountConstants.PROVIDER_INFO} /></span>}
                        name="Register Provider ID"
                        checked={props.orgValues.userRegister == 'registerProvider' ? true : false}
                      />
                      <FormControlLabel
                        value="registerNPI"
                        id="standard-radio-desc-contains"
                        control={<Radio color="primary" />}
                        label={<span>Register NPI<CustomHelpIcon msg={ManageAccountConstants.NPI_INFO} /></span>}
                        name="Register NPI"
                        checked={props.orgValues.userRegister == 'registerNPI' ? true : false}
                      />
                    </RadioGroup>
                  </div>
                  <div className="tab-holder tab-body mt-2">
                    <div className="tab-body-bordered p-2 m-0">
          <div className="form-wrapper form-wrapper-alignment sso-login-form">
            <div className="mui-custom-form input-xl field-xl ">
              <TextField
                required={props.orgValues.userRegister === 'registerProvider' ? true : false}
                id="provider-medicaid_id"
                label="Provider Medicaid ID"
                className="inline-lable-ttl"
                value={props.orgValues?.providerMedicaidID}
                onChange={handleChange("providerMedicaidID")}
                inputProps={{ maxLength: 30 }}
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                helperText={provMedIDErr && ErrorConst.PROVIDER_ID_REQ || null}
                error={provMedIDErr}
              />
            </div>
            {props.orgValues.userRegister == 'registerNPI' &&
              <div className="mui-custom-form with-select input-xl field-xl">
              <TextField
                id="provider_npi"
                label="Provider NPI"
                value={props.orgValues?.providerNPI}
                inputProps={{ maxLength: 30 }}
                onChange={handleChange("providerNPI")}
                placeholder=""
                className="inline-lable-ttl"
                InputLabelProps={{
                  shrink: true,
                }}
                required={props.orgValues.userRegister == 'registerNPI' ? true : false}
                helperText={provNPIReqErr && ErrorConst.PROVIDER_NPI_REQ || null}
                error={provNPIReqErr}
              />
            </div>}
            <div className="mui-custom-form with-select input-xl field-xl">
              <TextField
                required
                id="Provider_EIN"
                label={props.orgValues.userRegister == 'registerNPI' ? "Provider EIN/SSN" : <span>Provider EIN/SSN<CustomHelpIcon msg={ManageAccountConstants.NPI_FIELD_INFO}/></span>}
                value={props.orgValues?.providerEINSSN}
                inputProps={{ maxLength: 30 }}
                onChange={handleChange("providerEINSSN")}
                placeholder=""
                className="inline-lable-ttl"
                InputLabelProps={{
                  shrink: true,
                }}
                helperText={provEINErr && ErrorConst.PROVIDER_EIN_REQ || null}
                error={provEINErr}
              />
            </div>
            <div className="mui-custom-form with-select input-xl field-xl">
              <TextField
                required
                id="Provider_lctn_zip"
                label="Provider Location Zip Code"
                value={props.orgValues?.providerZipCode}
                inputProps={{ maxLength: 30 }}
                onChange={handleChange("providerZipCode")}
                placeholder=""
                className="inline-lable-ttl"
                InputLabelProps={{
                  shrink: true,
                }}
                helperText={provLocZipCodeErr && ErrorConst.PROVIDER_LOC_ZP_REQ || null}
                error={provLocZipCodeErr}
              />
            </div>
          </div>
          </div>
          </div>
          <div className="text-center mt-3">
            <div className="th-btnGroup">
              <Button
                title="Verify"
                variant="outlined"
                color="primary"
                className="btn btn-ic btn-save mr-3"
                onClick={verifyBtn}
              >
                Verify
              </Button>
              <Button
                title="Cancel"
                variant="outlined"
                color="primary"
                className="btn btn-cancel"
                onClick={() => {
                  props.setLandingPage(true)
                  props.setShowAddOrg(false)
                  props.setSuccessMessages([])
                  props.setErrorMessages([])
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
}
export default AddOrganization;
